import React, { Component } from 'react';
import {
  Container,
} from 'reactstrap';
import AnalyticsDashboard from '../components/Analytics/AnalyticsDashboard';

class BackOfficeAnalytics extends Component {

  componentDidMount = () => {
    this.props.log('BackOfficeAnalytics.js/componentDidMount');
  }

  render() {
    return (<Container>
      <AnalyticsDashboard {...this.props} />
    </Container>
    );
  }
}

export default BackOfficeAnalytics;
